module.exports = __webpack_public_path__ + "img/logoDenominacionSingleLine.c07c89d4.png";